import React, { useState } from 'react';
import { authFetch } from './auth'; // 인증된 fetch 함수
import { UploadCloud, File, CheckCircle, AlertTriangle } from 'lucide-react';

const OcrUploader = ({ onUploadComplete }) => {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('idle'); // idle | uploading | success | error
  const [message, setMessage] = useState('');

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setStatus('idle');
      setMessage(selectedFile.name);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('이미지 파일을 먼저 선택해주세요.');
      setStatus('error');
      return;
    }

    setStatus('uploading');
    setMessage('서버로 이미지 전송 중...');

    const formData = new FormData();
    formData.append('screenshot', file);

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await authFetch(`${backendUrl}/api/run-ocr`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || '알 수 없는 오류가 발생했습니다.');
      }
      
      setStatus('success');
      setMessage(result.message || '성공적으로 처리되었습니다.');
      console.log('Pipeline output:', result.output);

      // 데이터가 변경되었으므로 부모 컴포넌트에 알림
      if (onUploadComplete) {
        onUploadComplete();
      }

    } catch (error) {
      setStatus('error');
      setMessage(`오류: ${error.message}`);
    }
  };

  const StatusIcon = () => {
    switch (status) {
      case 'success': return <CheckCircle className="w-5 h-5 text-green-500" />;
      case 'error': return <AlertTriangle className="w-5 h-5 text-red-500" />;
      default: return <File className="w-5 h-5 text-gray-400" />;
    }
  };

  return (
    <div className="bg-white/5 border border-white/10 rounded-3xl p-6 my-8">
      <h3 className="text-xl font-bold text-white mb-4">OCR 데이터 업로더 (편집자용)</h3>
      <div className="flex flex-col sm:flex-row items-center gap-4">
        <label className="w-full sm:w-auto flex-shrink-0 px-6 py-3 flex items-center gap-3 bg-white/10 border border-white/20 rounded-xl cursor-pointer hover:bg-white/20 transition-colors">
          <UploadCloud className="w-5 h-5 text-white" />
          <span className="text-white font-semibold">이미지 선택</span>
          <input type="file" accept="image/*" onChange={handleFileChange} className="hidden" />
        </label>
        
        <div className="w-full flex-grow flex items-center gap-3 bg-black/20 rounded-xl px-4 py-3">
          <StatusIcon />
          <span className={`text-sm truncate ${status === 'error' ? 'text-red-400' : 'text-gray-300'}`}>
            {message || '업로드할 ETF 정보 스크린샷을 선택하세요.'}
          </span>
        </div>

        <button 
          onClick={handleUpload}
          disabled={!file || status === 'uploading'}
          className="w-full sm:w-auto flex-shrink-0 px-8 py-3 font-bold text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-all disabled:bg-gray-500 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {status === 'uploading' ? '처리 중...' : '업로드 및 처리'}
        </button>
      </div>
    </div>
  );
};

export default OcrUploader;
